const SESSION_ID_KEY = 'wildy_session_id';

export function getSessionId(): string {
  try {
    let id = localStorage.getItem(SESSION_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(SESSION_ID_KEY, id);
    }
    return id;
  } catch {
    // localStorage unavailable (SSR, private browsing edge cases) — return ephemeral id
    return crypto.randomUUID();
  }
}
